import { useState } from 'react';
import TravelCardService from './TravelCardService';

function useManageTravelCard() {
    const [travelCards, setTravelCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshTravelCards = async () => {
        setIsLoading(true);
        try {
            const response = await TravelCardService.getTravelCards();
            setTravelCards(response.data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addTravelCard = async (data) => {
        let result = true
        setIsLoading(true);
        try {
            await TravelCardService.addTravelCard(data);
            await refreshTravelCards();
        } catch (err) {
            result = false
            console.log(err)
            setError(err.response.data.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result
    };

    const deleteTravelCard = async (id) => {
        let result = true
        setIsLoading(true);
        try {
            await TravelCardService.deleteTravelCard(id);
            await refreshTravelCards();
        } catch (err) {
            console.log(err)
            setError(err);
            result = false
        } finally {
            setIsLoading(false);
        }
        return result
    };

    const updateTravelCard = async (id, data) => {
        let result = true;
        setIsLoading(true);
        try {
            await TravelCardService.updateTravelCard(id, data);
            await refreshTravelCards();
        } catch (err) {
            console.log(err)
            setError(err);
            result = false
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    return {
        travelCards,
        isLoading,
        error,
        addTravelCard,
        deleteTravelCard,
        updateTravelCard,
        refreshTravelCards
    };
}

export default useManageTravelCard;
